'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var log = require('debug')('ipfs:mfs:utils:update-mfs-root');

var _require = require('../../../utils'),
    MFS_ROOT_KEY = _require.MFS_ROOT_KEY;

var updateMfsRoot = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, cid) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            log("New MFS root will be ".concat(cid));
            _context.next = 3;
            return context.repo.datastore.put(MFS_ROOT_KEY, cid.buffer);

          case 3:
            return _context.abrupt("return", cid);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function updateMfsRoot(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = updateMfsRoot;